import React from "react";

import throttle from 'lodash.throttle';
import { IProductMaintenancePageProps, ProductMaintenancePage } from "./ProductMaintenancePage";
import { EVENT_HANDLER_THROTTLE_TIME } from "../../Consts";


const ProductMaintenancePageScrollListener: React.FC<IProductMaintenancePageProps> = (props) => {
    const [updatedScroll, setUpdatedScroll] = React.useState(0);
    React.useEffect(() => {
        window.addEventListener(
            "scroll",
            throttle(handleScroll, EVENT_HANDLER_THROTTLE_TIME, {
                trailing: true
            })
        );
        return  window.removeEventListener(
            "scroll",
            throttle(handleScroll, EVENT_HANDLER_THROTTLE_TIME, {
                leading: true
            })
        );
    }, []);
    const handleScroll = () => {
        setUpdatedScroll(window.scrollY);
    };
    return <ProductMaintenancePage {...props} updatedScroll={updatedScroll} />
    
}
export default ProductMaintenancePageScrollListener;